import { render } from "./PositionDetail.vue?vue&type=template&id=d9447980"
import script from "./PositionDetail.vue?vue&type=script&lang=js"
export * from "./PositionDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__